import { cn } from "~/lib/utils"

const Dialog = ({
  children,
  className,
  open,
  ...props
}: {
  children: React.ReactNode
  className?: string
  open?: boolean
}) => {
  return (
    <dialog
      className={cn("h-dialog modal-dialog", className)}
      open={open}
      {...props}
    >
      {children}
    </dialog>
  )
}

const DialogTitle = ({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}) => {
  return <h2 className={cn("modal-title", className)}>{children}</h2>
}

const DialogContent = ({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}) => {
  return <div className={cn("modal-content", className)}>{children}</div>
}

const DialogHeader = ({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}) => {
  return <div className={cn("modal-header", className)}>{children}</div>
}

const DialogCloseButton = ({
  className,
  ...props
}: {
  children?: React.ReactNode
  className?: string
}) => {
  return (
    <button className={cn("modal-close", className)} {...props}>
      <span>&times;</span>
    </button>
  )
}

const DialogBody = ({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}) => {
  return <div className={cn("modal-body", className)}>{children}</div>
}

const DialogFooter = ({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}) => {
  return <div className={cn("modal-footer", className)}>{children}</div>
}

export {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogHeader,
  DialogCloseButton,
  DialogBody,
  DialogFooter,
}
